import assocIndexOf from './_assocIndexOf.js';

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

export default listCacheHas;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_listCacheHas.js
// module id = 703
// module chunks = 7